<ngb-progressbar class="kt-loading-bar" *ngIf="(loader.progress$ | async) > 0" [value]="loader.progress$ | async" height="3px"></ngb-progressbar>

<div class="navbar-brand border-0 mt-0" >
	<kt-brand></kt-brand>
</div>

<kt-menu-horizontal></kt-menu-horizontal>
